<template>
  <div class="animated fadeIn" id="tab-reglements">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-search mr-2"></i>
          <strong>Recherche</strong>
          <div class="card-header-actions">
            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
              <span class="when-opened">
                <i class="icon-arrow-down"></i>
              </span>
              <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
            </b-link>
          </div>
        </div>
        <b-collapse id="collapse1" visible>
          <b-card-body>
            <b-form v-on:submit.prevent="searchByFilters">
              <b-row>
                <b-col sm="2">
                  <b-form-group>
                    <label for="type"><strong>Type</strong></label>
                    <b-form-select v-model="type" :options="types"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group>
                    <label for="date_du"><strong>Période du</strong></label>
                    <b-form-input type="date" id="date_du" v-model="date_du"
                                  :class="{hasError: errors.date_du !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.date_du }}</span>
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group>
                    <label for="date_au"><strong>Au</strong></label>
                    <b-form-input type="date" id="date_au" v-model="date_au"
                                  :class="{hasError: errors.date_au !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.date_au }}</span>
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group>
                    <label for="texte"><strong>Texte</strong></label>
                    <b-form-input type="text" id="nom" v-model="texte"
                                  :class="{hasError: errors.texte !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.texte }}</span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2">
                  <b-form-group>
                    <label for="montant"><strong>Montant</strong></label>
                    <b-form-input type="text" id="montant" v-model="montant"
                                  :class="{hasError: errors.montant !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.montant }}</span>
                  </b-form-group>
                </b-col>
                <b-col sm="1">
                  <b-form-group>
                    <label for="precision"><strong>Précision</strong></label>
                    <b-form-select v-model="precision" :options="precisions"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group>
                    <label for="siren"><strong>SIREN</strong></label>
                    <b-form-input type="text" id="siren" v-model="siren"
                                  :class="{hasError: errors.siren !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.siren }}</span>
                  </b-form-group>
                </b-col>
              </b-row>
              <div slot="footer">
                <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-1">
                  <i class="fa fa-eraser"></i> Effacer
                </b-button>
                <b-button type="enter" @click.prevent="search()" size="md" variant="primary" class="mr-1">
                  <i class="fa fa-search"></i> Rechercher
                </b-button>
                <b-button v-if="canAccess(rules.MANAGE_RPA_DATA)"
                  type="button"
                  @click="create()"
                  class="pull-right"
                  size="md"
                  variant="primary"
                >
                  <i class="fa fa-plus"></i> Ajouter un virement
                </b-button>
              </div>
            </b-form>
          </b-card-body>
        </b-collapse>
      </b-card>
    </transition>
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des Règlements</strong>
        <vue-excel-xlsx
          :data="excelData"
          :columns="excelColumns"
          v-bind:class="classObject"
          class="btn btn-success mr-1 pull-right"
          filename="export_reglements">
          <i class="fa fa-file-excel-o"></i>&nbsp; Exporter en Excel
        </vue-excel-xlsx>
        </b-card-header>
      <b-card-body>
        <reglement-table :tableEntry="tableParam" ref="reglement_table"></reglement-table>
      </b-card-body>
      <div slot="footer">

      </div>
    </b-card>
  </div>
</template>

<script>
  import {getBaseUrl, getProvider, getIdToken, getAccessToken} from '../../utils/auth'
  import {espaceRPARules, hasRule} from '../../utils/rulesHelper'
  import {fr} from 'vuejs-datepicker/dist/locale'
  import ReglementTable from '../../components/RPA/ReglementTable'

  export default {
    components: {ReglementTable},
    data() {
      return {
        rules: espaceRPARules,
        type: "",
        types: ["Tous", "Chèque", "Virement", "Télérèglement"],
        precisions: ["<=", "=>", "égale", "+-1 €", "+-2 €"],
        montant: "",
        texte: "",
        precision: "",
        siren: "",
        date_du: "",
        date_au: "",
        noSearch: "noSearch",
        errors: {date_au: '', date_du: '', montant: '', texte: '', siren: ''},
        fr: fr,
        DatePickerFormat: 'dd/MM/yyyy',
        excelColumns: [
          {
            label: 'Type',
            field: "type",
          },
          {
            label: "Montant",
            field: "montant",
          },
          {
            label: "Date execution",
            field: "date_execution",
          },
          {
            label: "Référence 1",
            field: "reference1",
          },
          {
            label: "Référence 2",
            field: "reference2",
          },
          {
            label: "Référence 3",
            field: "reference3",
          },
          {
            label: "Référence 4",
            field: "reference4",
          },
          {
            label: "Siren",
            field: "siren",
          },
          {
            label: "Statut",
            field: "statut",
          },
          {
            label: "Numéro TP",
            field: "numero_tp",
          },
          {
            label: "Gestionnaire",
            field: "gestionnaire",
          },
        ],
        excelData: [],
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    computed: {
      tableParam: {
        get() {
          let request = {};

          request.type = this.type
          request.precision = this.precision
          request.montant = this.montant.replace(/,/g, '.')
          this.montant = request.montant
          request.texte = this.texte;
          this.texte = request.texte;
          request.siren = this.siren.replace(/ /g, "")
          this.siren = request.siren
          request.date_du = this.date_du;
          request.date_au = this.date_au;
          request.noSearch = this.noSearch;

          return request;
        }
      },
      classObject: function () {
        return {
          'btn-disable': !this.excelData.length > 0,
        }
      }
    },
    methods: {
      canAccess(rule) {
        return hasRule(rule)
      },
      clearErrors() {
        this.errors.date_du = ''
        this.errors.date_au = ''
        this.errors.texte = ''
        this.errors.montant = ''
        this.errors.siren = ''
      },
      clearForm() {
        this.type = '';
        this.precision = '';
        this.date_du = ''
        this.date_au = ''
        this.texte = ''
        this.montant = ''
        this.siren = ''
      },
      formatNumber(num) {
        //return num;
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
      },
      search() {
        if (this.validateData()) {
          this.excelData = [];
          this.$store.commit("IS_LOADING", true);
          this.noSearch = "";
          setTimeout(this.$refs.reglement_table.$refs.table.refresh(), 3000);
          this.fetchData();
        }
      },
      create(){
        this.$router.push({ path: "/suivi-cotisations/reglements/create-virement" });
      },
      validateData() {
        this.clearErrors()
        let dateFrom = new Date(this.date_du)
        let dateTo = new Date(this.date_au)

        let regNumeric = this.$store.getters.getRegNumeric
        let valid = true

        let siren = this.siren.replace(/ /g, "")
        if (siren !== '') {
          if (!regNumeric.test(siren)) {
            this.errors.siren = 'Un SIREN ne doit contenir que des chiffres'
            valid = false
          } else if (siren.length > 9 || siren.length < 9) {
            this.errors.siren = 'Un SIREN doit contenir exactement 9 chiffres'
            valid = false
          }
        }

        let montant = this.montant.replace(/ /g, "")
        if (montant !== '') {
          if (isNaN(montant)) {
            this.errors.montant = 'Le montant doit contenir que des chiffres'
            valid = false
          } else if (montant.length > 15) {
            this.errors.montant = 'Le montant saisi est invalide'
            valid = false
          }
        }

        let texte = this.texte.replace(/ /g, "")
        if (texte !== '') {
          if (texte.length > 100) {
            this.errors.texte = 'Le texte recherché est trop long'
            valid = false
          }
        }

        if (this.date_au !== null && this.date_au !== "") {
          if (dateTo.getTime() < dateFrom.getTime()) {
            this.errors.date_au = "La date de fin doit être postérieure à la date de début";
            valid = false;
          }
        }

        return valid
      },
      async fetchData() {
        let request = {};
        request.type = this.type
        request.precision = this.precision
        request.montant = this.montant.replace(/ /g, "")
        this.montant = request.montant
        request.texte = this.texte;
        this.texte = request.texte;
        request.siren = this.siren.replace(/ /g, "")
        this.siren = request.siren
        request.date_du = this.date_du;
        request.date_au = this.date_au;
        request.noSearch = '';
        const response = await this.$axios.post(
          "/espaceRPA/reglements/export", request
        );
        for(let item of response.data.reglements.original.data) {
          this.excelData.push({
            type: item.type,
            montant: this.formatNumber(item.montant),
            date_execution: this.formatDate(item.date_execution),
            reference1: item.reference1,
            reference2: item.reference2,
            reference3: item.reference3,
            reference4: item.reference4,
            siren: item.siren && item.siren.substring(0, 9),
            statut: this.getStatus(item.statut),
            numero_tp: item.numero_tp,
            gestionnaire: item.gestionnaire,
          });
        }
      },
      formatDate(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
        return date;
      },
      getStatus(value) {
        switch (value) {
          case 'Traité' :
          case 'Encaissé' :
          case 'Encaissé avec non-ventilé' :
            return 'Encaissé sur NSI';
            break;
          case 'Neutralisé':
            return value;
            break;
          case  'En cours de traitement' :
          case  'En attente de traitement' :
          case 'En attente d\'envoi à la banque' :
            return 'Non encaissé sur NSI';
            break;
          default :
            return value;
            break;
        }
      }
    }
  }
</script>


<style>
  #tab-reglements .VueTables__table thead tr th:first-child {
    width: 7%;
  }

  #tab-reglements .VueTables__table thead tr th:nth-child(2) {
    width: 9%;
  }

  #tab-reglements .VueTables__table thead tr th:nth-child(3) {
    width: 8%;
  }

  #tab-reglements .VueTables__table thead tr th:nth-child(4) {
    width: 19%;
  }

  #tab-reglements .VueTables__table thead tr th:nth-child(5) {
    width: 8%;
  }

  #tab-reglements .VueTables__table thead tr th:nth-child(6) {
    width: 8%;
  }

  #tab-reglements .VueTables__table thead tr th:nth-child(7) {
    width: 8%;
  }

  #tab-reglements .VueTables__table thead tr th:nth-child(8) {
    width: 7%;
  }

  #tab-reglements .VueTables__table thead tr th:nth-child(9) {
    width: 9%;
  }

  #tab-reglements .VueTables__table thead tr th:nth-child(9) {
    width: 8%;
  }

  #tab-reglements .VueTables__table thead tr th:nth-child(9) {
    width: 9%;
  }
  .btn-disable {
    cursor: not-allowed;
    pointer-events: none;
    color: #c0c0c0;
    background-color: #ffffff;
  }
</style>
